@if (isReady) {
  <model-viewer
    [src]="src"
    auto-rotate
    data-js-focus-visible
    (model-visibility)="modelLoaded()"
    camera-controls>
  </model-viewer>
}
